// Back-to-top button: hidden until the visitor has scrolled past the fold.
const backToTopButton = document.querySelector('.js-back-to-top');

if (backToTopButton) {
	const SHOW_AFTER_PX = 400;

	window.addEventListener('scroll', () => {
		backToTopButton.classList.toggle('is-visible', window.scrollY > SHOW_AFTER_PX);
	}, { passive: true });

	backToTopButton.addEventListener('click', () => {
		window.scrollTo({ top: 0, behavior: 'smooth' });
	});
}
